import * as React from "react"
import Layout from "../components/layout";
import * as Container from "../components/container/container";
const pageTitle = "Orte der Demokratie - Verfassung Neu";
const IndexPage = (props) => {
    return (
        <Layout pageTitle={pageTitle} props={props}>
            <main id="main">
                <Container.HeaderPart background="white no-image">
                    <div className="headline">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <h1>Die Verfassung des Freistaates Bayern</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container.HeaderPart>
                <Container.Part background="white">
                    <Container.Row>
                        <div className="col-12">
                            <Container.Facsimile
                                pdf="/facsimile/09_03_Achtung! Bitte nur Seiten mit der Verfassung.pdf"
                                img="/images/Verfassung_neu.png"
                                alttext="Verfassung des Freistaats Bayern">
                                <figcaption>
                                    Verfassung des Freistaates Bayern
                                </figcaption>
                            </Container.Facsimile>
                        </div>
                    </Container.Row>
                </Container.Part>
            </main>
        </Layout>
    )
}

export default IndexPage